module.exports = __webpack_public_path__ + "static/media/g.bd387988.png";